import React, { useState } from "react";
import { Layout, Modal, message } from "antd";
import { useTranslation } from "react-i18next";

import AppLayout from "../../navigation/Layout/Layout";
import FamilyTree from "../components/FamilyTree/familyTree";
import AddRelativeForm from "../components/AddRelativeForm/AddRelativeForm";
import FamilyMedicalHistoryOverview from "../components/FamilyMedicalHistoryOverview/FamilyMedicalHistoryOverview";

import "./sousProfile.css";

const { Content } = Layout;

const initialAddRelativeModal = {
  open: false,
  forMember: null,
  onLinked: null,
};

const initialAiPanel = {
  open: false,
  loading: false,
  report: null,
};

export default function SousProfile() {
  const { t } = useTranslation("sousProfile");
  const [addRelativeModal, setAddRelativeModal] = useState(
    initialAddRelativeModal
  );

  const [aiPanel, setAiPanel] = useState(initialAiPanel);

  const closeAddRelativeModal = () => {
    setAddRelativeModal(initialAddRelativeModal);
  };

  const handleAddRelativeFromTree = (member, onLinked) => {
    setAddRelativeModal({
      open: true,
      forMember: member,
      onLinked,
    });
  };

  const handleRelativeDone = (linkInfo) => {
    if (
      typeof addRelativeModal.onLinked === "function" &&
      linkInfo
    ) {
      addRelativeModal.onLinked(linkInfo);
    }

    closeAddRelativeModal();
  };

  const handleAiStart = () => {
    setAiPanel({
      open: true,
      loading: true,
      report: null,
    });
  };

  const handleAiGenerated = (report) => {
    setAiPanel({
      open: true,
      loading: false,
      report,
    });
  };

  const handleAiError = () => {
    setAiPanel((prev) => ({
      ...prev,
      open: true,
      loading: false,
    }));
  };

  const closeAiPanel = () => {
    setAiPanel(initialAiPanel);
  };

  const handleSaveReport = () => {
    if (!aiPanel.report) {
      message.warning(t("familyTree.ui.noReport"));
      return;
    }

    try {
      const blob = new Blob(
        [JSON.stringify(aiPanel.report, null, 2)],
        { type: "application/json;charset=utf-8" }
      );

      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      const date = new Date().toISOString().slice(0, 10);

      link.href = url;
      link.download = `family-medical-report-${date}.json`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      URL.revokeObjectURL(url);

      message.success(t("familyTree.ui.reportSaved"));
    } catch (error) {
      console.error("Save AI report error:", error);
      message.error(t("familyTree.ui.saveError"));
    }
  };

  return (
    <AppLayout>
      <Content className="sousProfile-content">
        <div
          className={[
            "sousProfile-container",
            aiPanel.open ? "sousProfile-container--with-ai" : "",
          ]
            .filter(Boolean)
            .join(" ")}
        >
          <section className="sousProfile-tree-section">
            <FamilyTree
              onAddRelativeFromTree={handleAddRelativeFromTree}
              onAiStart={handleAiStart}
              onAiGenerated={handleAiGenerated}
              onAiError={handleAiError}
              aiPanelOpen={aiPanel.open}
              canSaveReport={Boolean(aiPanel.report)}
              onSaveReport={handleSaveReport}
            />
          </section>

          {aiPanel.open && (
            <FamilyMedicalHistoryOverview
              report={aiPanel.report}
              loading={aiPanel.loading}
              onClose={closeAiPanel}
            />
          )}
        </div>

        <Modal
          open={addRelativeModal.open}
          onCancel={closeAddRelativeModal}
          footer={null}
          centered
          width={520}
          title={t("familyTree.modal.addRelative")}
          className="sousProfile-add-relative-modal"
        >
          {addRelativeModal.forMember && (
            <AddRelativeForm
              slotMember={addRelativeModal.forMember}
              onDone={handleRelativeDone}
              onCancel={closeAddRelativeModal}
            />
          )}
        </Modal>
      </Content>
    </AppLayout>
  );
}
